module.exports = __webpack_public_path__ + "media/images/ticket/add_to_cart-0063045b635b21b7f388118bf7d609fc.png";